import styled from 'styled-components'
import { Collapse } from 'antd'

export const GroupWrapper = styled.div<{ $isMobile: boolean; $isFirst: boolean }>`
  margin-bottom: 12px;
`

export const StyledCollapse = styled(Collapse)`
  &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
    padding-left: 0;
    padding-right: 0;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }

  &.ant-collapse > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding-left: 0;
    padding-right: 0;
  }

  &.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-expand-icon {
    order: 2;
    margin-inline-start: 8px;
    margin-inline-end: 0;
  }

  &.ant-collapse>.ant-collapse-item >.ant-collapse-header .ant-collapse-header-text {
    margin: unset;
    flex: none;
  }
`

